import { render, staticRenderFns } from "./UserTrainingCourseCards.vue?vue&type=template&id=3682b22a&"
import script from "./UserTrainingCourseCards.vue?vue&type=script&lang=js&"
export * from "./UserTrainingCourseCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports